import React from 'react'
import { Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'
import './DateTimeCell.scss'

type DateTimeCellProps = {
  rowData?: Record<string, any>
  dataKey: string
  showTime?: boolean
}

const formatDateTime = (
  value: string,
  showTime: boolean
): { date: string; time: string; full: string } | null => {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null

  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')

  const date = `${day}/${month}/${year}`
  const time = showTime ? `${hours}:${minutes}` : ''

  return { date, time, full: showTime ? `${date} ${time}` : date }
}

const DateTimeCell: React.FC<DateTimeCellProps> = ({
  rowData,
  dataKey,
  showTime = true,
  ...props
}) => {
  const rawValue = rowData?.[dataKey] as string
  const formatted = formatDateTime(rawValue, showTime)

  return (
    <Whisper
      placement="bottom"
      trigger={formatted ? 'hover' : 'none'}
      speaker={<Tooltip>{formatted?.full ?? ''}</Tooltip>}
    >
      <Cell {...props}>
        {formatted ? (
          <span className="datetime-cell">
            <span className="datetime-cell__date">{formatted.date}</span>
            {formatted.time && (
              <span className="datetime-cell__time">{formatted.time}</span>
            )}
          </span>
        ) : (
          <span>—</span>
        )}
      </Cell>
    </Whisper>
  )
}

export default DateTimeCell
